import store from '@/store'

export default async (_to, _from, next) => {
  if (!store.getters['auth/check']) {
    next({ name: 'shared.login' })
  } else {
    next()
  }
}
